import { useState } from 'react';
import { IApiCallStatus, IDeaRegistration, ValueLabel } from '../common';
import { renderStack } from '.';
import { Pagination, styled } from '@mui/material';

export function RegistrationsStack({
  properties,
  deaRegistrations,
  getRegistrationsCallStatus,
}: {
  properties: ValueLabel<keyof IDeaRegistration>[];
  deaRegistrations: IDeaRegistration[];
  getRegistrationsCallStatus: IApiCallStatus;
}) {
  const [page, setPage] = useState(1);
  const pageSize = 100;

  switch (getRegistrationsCallStatus) {
    case null:
      return <article>Loading...</article>;

    case false:
      return <article>Error</article>;

    case true:
      return (
        <>
          {deaRegistrations.length > pageSize && (
            <Paginatio
              count={Math.ceil(deaRegistrations.length / pageSize)}
              page={page}
              onChange={(z, page) => setPage(page)}
              shape="rounded"
            />
          )}

          {renderStack(properties)(
            deaRegistrations.slice((page - 1) * pageSize, page * pageSize)
          )}

          {deaRegistrations.length > pageSize && (
            <Paginatio
              count={Math.ceil(deaRegistrations.length / pageSize)}
              page={page}
              onChange={(z, page) => setPage(page)}
              shape="rounded"
            />
          )}
        </>
      );

    case void 0:
      return null;
  }
}

const Paginatio = styled(Pagination)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
}));
